export const investorRelations = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://www.boldare.com/investor-relations/',
  description:
    'Boldare provides digital transformation services including software development, digital design, generative AI, product innovation & strategy, quality & project management, DevOps & infrastructure, consulting & scaling, and testing & quality. The company also offers development capacity scaling through dedicated teams and team augmentation.',
  foundingDate: '2013',
};
